
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class BaseModal extends Vue {

    @Prop({ type: String, default: "" }) readonly title!: string;

}
